import React from 'react';
import PropTypes from 'prop-types';
import './AuthTransition.css';

const AuthenticationTransition = ({
  message,
  status,
  error,
  onRetry,
  isLoading,
}) => {
  return (
    <div className="auth-transition-overlay">
      <div className="auth-transition-content">
        {isLoading && <div className="auth-transition-spinner" />}

        <div className="auth-transition-message">
          {message || 'Processing authentication...'}
        </div>

        {status && <div className="auth-transition-status">{status}</div>}

        {error && (
          <div className="auth-error">
            <span className="auth-error-icon">⚠</span>
            {error}
            {onRetry && (
              <button
                className="auth-retry-button"
                onClick={onRetry}
                disabled={isLoading}
              >
                Try Again
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

AuthenticationTransition.propTypes = {
  message: PropTypes.string,
  status: PropTypes.string,
  error: PropTypes.string,
  onRetry: PropTypes.func,
  isLoading: PropTypes.bool,
};

AuthenticationTransition.defaultProps = {
  message: 'Processing authentication...',
  isLoading: true,
};

export default AuthenticationTransition;
